/**
 * WWG Store App Categories tree (Category Builder source).
 *
 * Mirrors the real DEV `Categories` collection so mock/offline mode matches
 * what QA sees. Nested nodes: { code, title, level, children: Node[] }. Codes
 * match the `storeAppCategories` values a product carries.
 */
const categories = [
  {
    code: "LITERATURE",
    title: "Literature",
    level: 1,
    children: [
      {
        code: "LITERATURE_BOOKS",
        title: "Books",
        level: 2,
        children: [
          {
            code: "LITERATURE_BOOKS_BUSINESS",
            title: "Business",
            level: 3,
            children: [],
          },
          {
            code: "LITERATURE_BOOKS_KIDS",
            title: "Kids",
            level: 3,
            children: [],
          },
          {
            code: "LITERATURE_BOOKS_LEADERSHIP",
            title: "Leadership",
            level: 3,
            children: [],
          },
          {
            code: "LITERATURE_BOOKS_MOTIVATIONAL",
            title: "Motivational",
            level: 3,
            children: [],
          },
          {
            code: "LITERATURE_BOOKS_OVERCOMING",
            title: "Overcoming",
            level: 3,
            children: [],
          },
          {
            code: "LITERATURE_BOOKS_RELATIONSHIPS",
            title: "Relationships",
            level: 3,
            children: [],
          },
          {
            code: "LITERATURE_BOOKS_SELF IMPROVEMENT",
            title: "Self Improvement",
            level: 3,
            children: [],
          },
        ],
      },
      {
        code: "LITERATURE_INFO",
        title: "Info",
        level: 2,
        children: [
          { code: "LITERATURE_INFO_BOV", title: "BOV", level: 3, children: [] },
          {
            code: "LITERATURE_INFO_BROCHURE",
            title: "Brochure",
            level: 3,
            children: [],
          },
        ],
      },
      {
        code: "LITERATURE_STATIONARY",
        title: "Stationary",
        level: 2,
        children: [
          {
            code: "LITERATURE_STATIONARY_PAPER PRODUCTS",
            title: "Paper Products",
            level: 3,
            children: [],
          },
          {
            code: "LITERATURE_STATIONARY_WRITING PRODUCTS",
            title: "Writing Products",
            level: 3,
            children: [],
          },
          {
            code: "LITERATURE_STATIONARY_STORAGE",
            title: "Storage",
            level: 3,
            children: [],
          },
        ],
      },
      { code: "LITERATURE_BUNDLES", title: "Bundles", level: 2, children: [] },
    ],
  },
  {
    code: "CLOTHING",
    title: "Clothing",
    level: 1,
    children: [
      { code: "CLOTHING_HATS", title: "Hats", level: 2, children: [] },
      { code: "CLOTHING_BUNDLES", title: "Bundles", level: 2, children: [] },
    ],
  },
  {
    code: "DRINKWARE",
    title: "Drinkware",
    level: 1,
    children: [
      { code: "DRINKWARE_TUMBLERS", title: "Tumblers", level: 2, children: [] },
      {
        code: "DRINKWARE_SHAKER BOTTLES",
        title: "Shaker Bottles",
        level: 2,
        children: [],
      },
      { code: "DRINKWARE_BUNDLES", title: "Bundles", level: 2, children: [] },
    ],
  },
  {
    code: "ACCESSORIES",
    title: "Accessories",
    level: 1,
    children: [
      { code: "ACCESSORIES_BAGS", title: "Bags", level: 2, children: [] },
      { code: "ACCESSORIES_PINS", title: "Pins", level: 2, children: [] },
      { code: "ACCESSORIES_BUNDLES", title: "Bundles", level: 2, children: [] },
    ],
  },
];

export default categories;
